import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    iconButton: {
        width: '150px',
        height: '32px',
        margin: '0 0 20px 20px ',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#3b5998',
        borderRadius: '4px',
        color: 'white',
        '&:hover': {
            backgroundColor: '#3b5998',
        }
    },
    fileInput: {
        display: 'none'
    },
    fileInfoContainer: {
        display: 'flex',
        alignItems: 'center',
        margin: '0 0 20px 20px ',
    },
    fileName: {
        maxWidth: '300px',
        maxHeight: '32px',
        marginRight: '4px',
        padding: '4px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        border: '1px solid gray',
        borderRadius: '4px'
    },
    buttonFile: {
        width: '90px',
        margin: '0 8px',
        fontWeight: 'bold'
    },
    iconDownContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    iconDown: {
        width: '40px',
        color: 'black'
    }
}))